export class AtlasOrganization {
    'id';
    'name';
    'atlasOrganizationId';
    'state';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasOrganizationId",
            "baseName": "atlasOrganizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "AccountState",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AtlasOrganization.attributeTypeMap;
    }
    constructor() {
    }
}
